import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

// Import components
import { Heading } from 'components/elements';

// Import styles
import { iconClock } from 'components/styles';

// Import assets
import PortalLogo from 'assets/icons/nexgentv_go.svg';

// Import icons
import { ReactComponent as IconClock } from 'assets/icons/ic_clock.svg';

export const PopoverWrapper = styled.div`
	height: 26rem;
	display: flex;
	color: ${({ theme }) => theme.grayMedium};
	overflow: hidden;
	background-color: ${({ theme: { popover } }) => popover.bg};

	${({ dragged }) =>
		dragged &&
		css`
			display: none;
		`};
`;

export const Container = styled.div`
	width: ${({ isMobile }) => (isMobile ? 20 : 28)}rem;
	display: flex;
	flex-direction: column;
`;

export const PlaceholderContainer = styled.div`
	flex: 1;
	padding: 1.5rem;
`;

export const PlaceholderText = styled(Heading.Third)`
	color: ${({ theme }) => theme.grayMedium};
	font-size: 1.4rem;
	font-weight: ${({ theme }) => theme.font.medium};
	margin-bottom: 0.4rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Preview = styled.div`
	width: 26rem;
	background: url(${PortalLogo}) 50% /80% auto ${({ theme }) =>
			theme.primaryDark} no-repeat;
`;
export const Image = styled.img`
	height: 100%;
	width: 100%;
	object-fit: cover;
	display: ${({ isLoaded }) => (isLoaded ? 'block' : 'none')};
`;

export const Content = styled.div`
	flex: 1;
	padding: 1.5rem;
`;

export const Top = styled.div`
	margin-bottom: 0.8rem;
`;

export const Clock = styled(IconClock)`
	position: relative;
	top: 0.1rem;
	${iconClock};

	g,
	path {
		fill: ${({ theme }) => theme.grayMedium};
	}
`;

export const Time = styled.span`
	font-weight: ${({ theme }) => theme.font.medium};
`;

export const Title = styled(Heading.Third)`
	color: ${({ theme }) => theme.grayMedium};
	font-size: 1.4rem;
	font-weight: ${({ theme }) => theme.font.medium};
	margin-bottom: 0.4rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Genres = styled.span`
	font-size: 1.2rem;
	margin-bottom: 0.4rem;
	margin-right: 1rem;
`;

export const Description = styled.p`
	font-size: 1.2rem;
	font-weight: ${({ theme }) => theme.font.normal};
	margin: 1rem 0;
`;

export const LinkStyled = styled(Link)`
	&:link,
	&:visited {
		margin-left: 0.4rem;
		color: ${({ theme }) => theme.grayMedium};
		transition: all 0.3s ease-in-out;
	}
	&:hover,
	&:active {
		color: ${({ theme }) => theme.primary};
	}
`;
